export default __webpack_public_path__ + "static/media/field_any_unpacked.c7fa0143.png";